'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchFitnessTotals = exports.fetchFitnessSummary = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _client = require('../../utils/client');

var _params = require('../../utils/params');

var _pick = require('lodash/pick');

var _pick2 = _interopRequireDefault(_pick);

var _isEmpty = require('lodash/isEmpty');

var _isEmpty2 = _interopRequireDefault(_isEmpty);

var _fitnessTypes = require('./consts/fitness-types');

var _fitnessTypes2 = _interopRequireDefault(_fitnessTypes);

var _campaigns = require('../campaigns');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var fetchFitnessSummary = exports.fetchFitnessSummary = function fetchFitnessSummary() {
  var campaign = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _params.required)();
  var types = arguments[1];

  if ((0, _client.isJustGiving)()) {
    return Promise.reject('This method is not supported for JustGiving');
  } else {
    return Array.isArray(campaign) ? (0, _campaigns.fetchCampaigns)({ ids: campaign }).then(function (results) {
      return results.map(function (result) {
        return deserializeOverview(result);
      });
    }).then(function (results) {
      return combineMultipleCampaigns(results);
    }).then(function (results) {
      return types ? filterTypes(results, types) : results;
    }).catch(function (err) {
      return console.log(err);
    }) : (0, _campaigns.fetchCampaign)(campaign).then(function (result) {
      return deserializeOverview(result);
    }).then(function (results) {
      return types ? filterTypes(results, types) : results;
    }).catch(function (err) {
      return console.log(err);
    });
  }
};

var fetchFitnessTotals = exports.fetchFitnessTotals = function fetchFitnessTotals() {
  var campaign = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _params.required)();
  var types = arguments[1];
  return fetchFitnessSummary(campaign, types).then(function (summary) {
    return Object.keys(summary).reduce(function (result, item, i) {
      return {
        duration: result.duration + summary[item].duration,
        calories: result.calories + summary[item].calories,
        distance: result.distance + summary[item].distance
      };
    }, { duration: 0, calories: 0, distance: 0 });
  }).catch(function (err) {
    return console.log(err);
  });
};

var deserializeOverview = function deserializeOverview(_ref) {
  var overview = _ref.fitness_activity_overview;
  return _fitnessTypes2.default.reduce(function (result, fitnessType, i) {
    var key = overview[fitnessType] || {};
    return _extends({}, result, _defineProperty({}, fitnessType, {
      duration: key.duration_in_seconds || 0,
      calories: key.calories || 0,
      distance: key.distance_in_meters || 0
    }));
  }, {});
};

var combineMultipleCampaigns = function combineMultipleCampaigns(campaigns) {
  return _fitnessTypes2.default.reduce(function (result, fitnessType, i) {
    return _extends({}, result, _defineProperty({}, fitnessType, {
      duration: addValuesFromAllCampaigns(campaigns, fitnessType, 'duration'),
      calories: addValuesFromAllCampaigns(campaigns, fitnessType, 'calories'),
      distance: addValuesFromAllCampaigns(campaigns, fitnessType, 'distance')
    }));
  }, {});
};

var addValuesFromAllCampaigns = function addValuesFromAllCampaigns(campaigns, fitnessType, key) {
  return campaigns.reduce(function (result, campaign, i) {
    return result + campaign[fitnessType][key];
  }, 0);
};

var filterTypes = function filterTypes(results, types) {
  var filtered = (0, _pick2.default)(results, types);
  return !(0, _isEmpty2.default)(filtered) ? filtered : results;
};


//////////////////
// WEBPACK FOOTER
// ../~/supporticon/api/fitness-totals/index.js
// module id = 1325
// module chunks = 0